import { intl } from 'lang/intl'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton } from '@23/ui-react'

import { useConfirmationModal } from '../../../../../../../global/hooks/useConfirmationModal'

interface DeleteFieldConfirmationModalProps {
  onConfirm: () => void
  onCancel: () => void
}

const CloseConfirmation = ({
  onConfirm,
  onCancel,
}: DeleteFieldConfirmationModalProps) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <FormattedMessage defaultMessage="This means that you won’t be able to start it again to collect more votes." />
      <TtButton
        slot="footer"
        color="danger"
        pill
        onClick={() => {
          onConfirm()
          setIsLoading(true)
        }}
        loading={isLoading}
      >
        <FormattedMessage defaultMessage="Yes, close it" />
      </TtButton>
      <TtButton
        slot="footer"
        color="secondary"
        variant="outline"
        pill
        disabled={isLoading}
        onClick={onCancel}
      >
        <FormattedMessage defaultMessage="Cancel" />
      </TtButton>
    </>
  )
}

const useClosePollConfirmationModal = () => {
  return useConfirmationModal(CloseConfirmation, {
    title: intl.formatMessage({
      defaultMessage: 'You are about to close this poll.',
    }),
  })
}

export { useClosePollConfirmationModal }
